import React from "react";
import { withStyles } from "@material-ui/core/styles";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import Button from "@material-ui/core/Button";
import classNames from "classnames";
import styles from "./cardStyle-jss";
import Typography from "@material-ui/core/Typography";
import { S3Image } from "aws-amplify-react";
import { getUrlImage } from "../../service/s3Amplify";

const validateUrl = value =>
  value && /^(ftp|http|https):\/\/[^ "]+$/.test(value) ? "Invalid" : undefined;

class ColumnCard extends React.Component {
  _isMounted = false;

  state = {
    url: "",
    attachmentUrl: ""
  };

  componentWillReceiveProps(newProps) {
    if (!validateUrl(newProps.image)) {
      getUrlImage(newProps.image).then(response => {
        if (this._isMounted) {
          this.setState({
            url: response
          });
        }
      });
    } else {
      if (this._isMounted) {
        this.setState({
          url: newProps.image
        });
      }
    }
    // handle attachment (pdf/doc file stored in S3)
    if (newProps.attachment) {
      if (!validateUrl(newProps.attachment)) {
        getUrlImage(newProps.attachment).then(response => {
          if (this._isMounted) {
            this.setState({ attachmentUrl: response });
          }
        }).catch(() => {
          if (this._isMounted) {
            this.setState({ attachmentUrl: "" });
          }
        });
      } else {
        if (this._isMounted) {
          this.setState({ attachmentUrl: newProps.attachment });
        }
      }
    } else {
      if (this._isMounted) {
        this.setState({ attachmentUrl: "" });
      }
    }
  }

  componentDidMount() {
    this._isMounted = true;
    // initialize attachmentUrl on mount
    const { image, attachment } = this.props;
    if (image) {
      if (!validateUrl(image)) {
        getUrlImage(image).then(response => {
          if (this._isMounted) {
            this.setState({ url: response });
          }
        }).catch(() => { });
      } else {
        this.setState({ url: image });
      }
    }
    if (attachment) {
      if (!validateUrl(attachment)) {
        getUrlImage(attachment).then(response => {
          if (this._isMounted) {
            this.setState({ attachmentUrl: response });
          }
        }).catch(() => { });
      } else {
        this.setState({ attachmentUrl: attachment });
      }
    }
  }

  componentWillUnmount() {
    this._isMounted = false;
  }

  getFilenameFromKey(key) {
    try {
      const parts = key.split('/');
      return parts[parts.length - 1];
    } catch (e) {
      return 'file';
    }
  }

  handleRead = (e) => {
    e && e.preventDefault && e.preventDefault();
    const { attachmentUrl } = this.state;
    if (!attachmentUrl) return;
    const encodedUrl = encodeURIComponent(attachmentUrl);
    const newWindow = window.open(`https://docs.google.com/gview?embedded=true&url=${encodedUrl}`,'_blank','noopener,noreferrer');
    if (newWindow) {
      newWindow.opener = null;
    }
  }

  handleDownload = async (e) => {
    e && e.preventDefault && e.preventDefault();
    const { attachmentUrl } = this.state;
    const { attachment } = this.props;
    if (!attachmentUrl) return;
    try {
      const response = await fetch(attachmentUrl);
      if (!response.ok) {
        throw new Error('Download failed');
      }
      const blob = await response.blob();
      const downloadUrl = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = downloadUrl;
      link.download = this.getFilenameFromKey(attachment || attachmentUrl);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(downloadUrl);
    } catch (error) {
      const fallbackWindow = window.open(attachmentUrl, '_blank', 'noopener,noreferrer');
      if (fallbackWindow) {
        fallbackWindow.opener = null;
      }
    }
  }

  getColorTitle(secColor) {
    if (secColor && (secColor.includes("#") && secColor.toLowerCase() != "#ffffff")) {
      return "#FFFFFF"
    }
  }

  getColorButton(secColor) {
    if (secColor.includes("#")) {
      return secColor
    } else {
      return "#FFFFFF"
    }
  }

  render() {
    const {
      classes,
      title,
      autor,
      description,
      small,
      image,
      attachment,
      busqueda,
      publish_date,
      colorTitle,
      sendEvent,
      inCarousel,
      isSearching
    } = this.props;

    return (
      <Card
        className={classNames(
          isSearching ? classes.cardSearching : classes.cardColumn,
          inCarousel && classes.cardColumnCarousel,
          busqueda && classes.busqueda
        )}
        onClick={isSearching ? sendEvent : null}
      >
        {/* Columna 1: Imagen */}
        {image && (
          <div className={classNames(
            classes.mediaColumn,
            inCarousel && classes.mediaColumnCarousel,
            isSearching && classes.mediaColumnSmall
          )}>
            <S3Image
              imgKey={image}
            />
          </div>
        )}

        {/* Columna 2: Contenido */}
        <CardContent className={isSearching ? classes.contenidoColumnSearching : classes.contenidoColumn}>
          {/* Header: Título y Autor */}
          <div className={classes.columnHeader}>
            {(title && !isSearching) && <Typography
              className={classNames(
                classes.mb1, classes.title
              )}
              style={{ color: this.getColorTitle(colorTitle) }}
            >
              {title}
            </Typography>}

            {autor && <div className={classes.wrapperAutor}>
              <Typography
                component="p"
                className={classNames(classes.kicker, isSearching && classes.noMB)}
                style={{ color: this.getColorTitle(colorTitle) }}
              >{autor}</Typography>
              {publish_date && (
                <Typography component="small" className={classes.date}>| {publish_date}</Typography>
              )}
            </div>}

            {(title && isSearching) && <Typography
              className={classNames(classes.title)}
              style={{ color: this.getColorTitle(colorTitle) }}
            >
              {title}
            </Typography>}


            {(description && !isSearching) && (
              <Typography component="p" className={classes.descriptionWrap8}>
                <span
                  className={classes.textDescriptionWrap8}
                  style={{ color: colorTitle && colorTitle.includes("#") && colorTitle.toLowerCase() != "#ffffff" ? "white" : "" }}
                  dangerouslySetInnerHTML={{ __html: `${description}` }}
                />
              </Typography>
            )}
          </div>

          {/* Footer: Botón */}
          {!isSearching && <div className={classes.columnFooter}>
            <Button
              onClick={(e) => { this.handleRead(e); if (sendEvent) sendEvent(e); }}
              disabled={!this.state.attachmentUrl}
              className={classNames(classes.colorPrimary, classes.button, classes.buttonVertical, !this.state.attachmentUrl && classes.disabledPrimary)}
            >
              Ver en línea
            </Button>
            <Button
              onClick={(e) => { this.handleDownload(e); }}
              disabled={!this.state.attachmentUrl}
              variant="outlined"
              className={classNames(classes.button, classes.buttonVertical, classes.borderPrimary)}
            >
              Guardar
            </Button>
          </div>}
        </CardContent>
      </Card>
    );
  }
}

export default withStyles(styles)(ColumnCard);
